import script from "./customSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./customSelect.vue?vue&type=script&lang=ts&setup=true"

import "./customSelect.scss?vue&type=style&index=0&id=0377e31f&scoped=true&lang=scss"

import exportComponent from "/home/sergiy/projects/magnetics/promo.land/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0377e31f"]])

export default __exports__